import * as moment from 'moment';
import { IPublicUser } from '../_interfaces/IUser';

export interface INewComment {
    photo_id: number;
    collection_id: number;
    text?: string;
    audio_file?: Blob;
    audio_length_ms?: number;
    parent_id?: string;
}

export interface IServerComment extends INewComment {
    audio_uri?: string;
    _id: string;
    user_id: number;
    created_at: number;
}

export abstract class Comment {
    public readonly id: string;
    public readonly photoID: number;
    public readonly storyID: number;
    public readonly parentID: string | undefined;

    public readonly children: Array<Comment>;
    public readonly author: IPublicUser;
    public readonly createdAt: moment.Moment;

    public constructor(data: IServerComment, children: Array<Comment>, author: IPublicUser) {
        this.id = data._id;
        this.photoID = data.photo_id;
        this.storyID = data.collection_id;
        this.parentID = data.parent_id;
        this.children = children;
        this.author = author;
        this.createdAt = moment(data.created_at);
    }

    public get replyParentId(): string {
        return !this.parentID ? this.id : this.parentID;
    }
}

export class TextComment extends Comment {
    public readonly text: string;

    public constructor(data: IServerComment, children: Array<Comment>, author: IPublicUser) {
        super(data, children, author);

        console.assert(data.text, 'Cannot create a text comment without text');

        this.text = data.text!;
    }
}

export class AudioComment extends Comment {
    public readonly audioURL: string;
    public readonly audioLengthMS: number;

    public constructor(data: IServerComment, children: Array<Comment>, author: IPublicUser) {
        super(data, children, author);

        console.assert(data.audio_uri, 'Cannot create an audio comment without an audio_uri');
        console.assert(data.audio_length_ms, 'Cannot create an audio comment without an audio length');

        this.audioURL = data.audio_uri!;
        this.audioLengthMS = data.audio_length_ms!;
    }
}



// WEBPACK FOOTER //
// ./src/Models/Comment.ts